import { useSizeGuide } from "./use-size-guide";
import { SizeGuideHeading } from "./size-guide-heading";
import { MeasurementStep } from "./measurement-step";
import { SizeGuideTableWrapper } from "./size-guide-table-wrapper";
import { SizeGuideFooter } from "./size-guide-footer";
import { useTranslate } from "@made-people/grease-translations";

export const PantyCharts = () => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  if (!sizeGuide) return null;

  return (
    <>
      <SizeGuideHeading title={translate("Size_Guide_Panties_Title")}>
        <div>{translate("Size_Guide_Panties_Description")}</div>
        <MeasurementStep
          number={1}
          text={translate("Size_Guide_Panties_How_To_Measure_Step_1")}
        />

        <MeasurementStep
          number={2}
          text={translate("Size_Guide_Panties_How_To_Measure_Step_2")}
        />
      </SizeGuideHeading>

      {sizeGuide.pantiesUpdatedTable && (
        <SizeGuideTableWrapper
          tableData={sizeGuide.pantiesUpdatedTable}
          title={translate("Size_Guide_Panties_Table_Title")}
        />
      )}

      {sizeGuide.pantiesUpdatedDoubleSizeTable && (
        <SizeGuideTableWrapper
          tableData={sizeGuide.pantiesUpdatedDoubleSizeTable}
          title={translate("Size_Guide_Panties_Double_Sizes_Title")}
        />
      )}
      <div>
        <div className="pt-[1.6rem] text-heading-xl font-secondary text-balance mb-3 lg:mb-4">
          {translate("Size_Guide_Girdles_Title")}
        </div>
        <div>{translate("Size_Guide_Girdles_Description")}</div>
      </div>
      <SizeGuideFooter />
    </>
  );
};
